import { Camera, Video, Download, Usb, Radio } from "lucide-react";

const MAP = {
  photos: { label: "Photos", icon: Camera, cls: "bg-rose-500/15 text-rose-400 border-rose-500/30" },
  video: { label: "Video", icon: Video, cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  download: { label: "Download", icon: Download, cls: "bg-cyan-500/15 text-cyan-400 border-cyan-500/30" },
  usb: { label: "USB Drive", icon: Usb, cls: "bg-violet-500/15 text-violet-400 border-violet-500/30" },
  livestream: { label: "Livestream", icon: Radio, cls: "bg-red-500/15 text-red-400 border-red-500/30" },
};

const STATUS = {
  instant_download: { label: "Instant Download", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  pre_order: { label: "Pre-Order", cls: "bg-purple-500/15 text-purple-400 border-purple-500/30" },
  pre_release: { label: "Pre-Release", cls: "bg-blue-500/15 text-blue-400 border-blue-500/30" },
  closed: { label: "Closed", cls: "bg-zinc-800 text-zinc-400 border-zinc-700" },
  expired: { label: "Expired", cls: "bg-zinc-800 text-zinc-500 border-zinc-700" },
};

export function MediaTypeBadges({ types = [], testidPrefix = "media-type" }) {
  return (
    <div className="flex flex-wrap gap-2">
      {types.map((t) => {
        const m = MAP[t];
        if (!m) return null;
        const Icon = m.icon;
        return (
          <span
            key={t}
            data-testid={`${testidPrefix}-${t}`}
            className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium ${m.cls}`}
          >
            <Icon className="h-3 w-3" />
            {m.label}
          </span>
        );
      })}
    </div>
  );
}

export function StatusBadge({ status }) {
  const s = STATUS[status] || STATUS.instant_download;
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${s.cls}`}>
      {s.label}
    </span>
  );
}

export { STATUS, MAP };

export const IMAGE_BADGES = {
  pre_order: { label: "Pre-order", cls: "bg-purple-500/25 text-purple-100 border-purple-500/40" },
  instant_download: { label: "Instant Download", cls: "bg-emerald-500/25 text-emerald-100 border-emerald-500/40" },
  unavailable: { label: "No longer available", cls: "bg-black/70 text-zinc-200 border-zinc-500" },
};
